import React, { useEffect, useState } from 'react';
import { MoSeries, Wrapper, Banner } from './styled';
import Layout from '../../components/Layout';
import { Link } from 'react-router-dom';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { GetPosts, GetSeriesNum, GetSliders } from '../../service/blog';
import { useRecoilState, useRecoilValue } from 'recoil';
import { seriresAtom, seriresNumAtom, shuffleAtom } from '../../atom/taxonomy';
import {
	SkeletonHome,
	SkeletonHomeArt,
	SkeletonHomePocket,
	SkeletonSeriess,
} from '../../components/Skeleton';

const Home = () => {
	const dummy = [
		{
			title: '마케터가 회사에서 덕업일치 하는 법',
			banner: '/images/main-banner.png',
		},
		{
			title: '마케터가 회사에서 덕업일치 하는 법',
			banner: '/images/main-banner.png',
		},
		{
			title: '마케터가 회사에서 덕업일치 하는 법',
			banner: '/images/main-banner.png',
		},
	];

	const [items, setItems] = useState([]);
	const [sliders, setSliders] = useState([]);
	const [seriesNum, setSeriesNum] = useRecoilState(seriresNumAtom);
	const series = useRecoilValue(seriresAtom);
	const [shuffle, setShuffle] = useRecoilState(shuffleAtom);

	useEffect(() => {
		GetSliders({
			paged: 1,
		})
			.then((res) => {
				console.log(res);
				if (res.data.code == 200) {
					setSliders(res.data.body.items);
				} else {
					setSliders(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
		GetPosts({
			paged: 1,
			postsPerPage: 8,
		})
			.then((res) => {
				console.log(res);
				if (res.data.code == 200) {
					setItems(res.data.body.items);
				} else {
					setItems(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
		GetSeriesNum({})
			.then((res) => {
				console.log(res);

				const sortedObjects = [...res.data.body.array]; // Create a copy of the array
				sortedObjects.sort((a, b) => b.value - a.value); // Sort by 'count' in ascending order

				console.log(123, sortedObjects);
				setSeriesNum(sortedObjects);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	function shuffleArray(array) {
		const shuffledArray = [...array]; // Create a copy of the original array
		for (let i = shuffledArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledArray[i], shuffledArray[j]] = [
				shuffledArray[j],
				shuffledArray[i],
			];
		}
		return shuffledArray;
	}

	useEffect(() => {
		// Used like so
		console.log(66, shuffle);
		const shuffledObjects = shuffleArray(shuffle);
		console.log(77, shuffledObjects);
		setShuffle(shuffledObjects);
	}, []);

	var saveBtn = document.getElementById('save-btn');

	const onclick = () => {
		var contact = {
			name: 'John Smith',
			phone: '555-555-5555',
			email: 'john@example.com',
		};

		var vcard =
			'BEGIN:VCARD\nVERSION:4.0\nFN:' +
			contact.name +
			'\nTEL;TYPE=work,voice:' +
			contact.phone +
			'\nEMAIL:' +
			contact.email +
			'\nEND:VCARD';
		var blob = new Blob([vcard], { type: 'text/vcard' });
		var url = URL.createObjectURL(blob);

		const newLink = document.createElement('a');
		newLink.download = contact.name + '.vcf';
		newLink.textContent = contact.name;
		newLink.href = url;

		newLink.click();
	};

	return (
		<Layout>
			<Wrapper>
				{sliders?.length ? (
					<div className="main-wrapper">
						<Swiper
							modules={[Navigation, Pagination, Scrollbar, A11y]}
							spaceBetween={20}
							slidesPerView={1}
							loop={true}
							navigation={{
								prevEl: '.swiper-button-prev',
								nextEl: '.swiper-button-next',
							}}
							pagination={{ clickable: true }}
							onSwiper={(swiper) => console.log(swiper)}
							onSlideChange={() => console.log('slide change')}
						>
							{sliders?.map((item, key) => (
								<SwiperSlide>
									<div className="flex" key={key}>
										<div className="left-box">
											{item.series ? (
												<p>
													<img src="/images/icon-lightning.svg" alt="" />
													{item.series}
												</p>
											) : (
												<p></p>
											)}
											<h2>{item.postTitle}</h2>
											<Link to={`/blog/${item.ID}`}>
												<div className="more-btn">자세히 보기</div>
											</Link>
										</div>

										<div className="right-box">
											<Link to={`/blog/${item.ID}`}>
												<div
													className="banner"
													style={{
														backgroundImage: `url(${
															item?.thumbnail || '/images/no-image3.png'
														})`,
													}}
												></div>
											</Link>
										</div>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
						<div className="swiper-button-prev"></div>
						<div className="swiper-button-next"></div>
					</div>
				) : (
					<>
						<SkeletonHome />
					</>
				)}
				<MoSeries>
					<h2 onClick={() => console.log(series)}>포켓</h2>

					<div className="series-wrap">
						<Swiper
							spaceBetween={10}
							slidesPerView={1}
							centeredSlides={true}
							loop={true}
							onSlideChange={() => console.log('slide change')}
							onSwiper={(swiper) => console.log(swiper)}
						>
							{seriesNum?.length ? (
								seriesNum.map((item, key) => (
									<SwiperSlide key={key}>
										<Link to={`/blog/series/${item.key}`}>
											<Banner
												className="banner"
												style={{
													backgroundImage: `url(${shuffle[key]?.thumbnail})`,
												}}
												moThumbnail={shuffle[key]?.m}
											>
												{/* <p className="title">{series[item?.key]?.title}</p> */}
												<p className="title">{item?.title}</p>
												<p className="total">{item?.value}개 게시글</p>
											</Banner>
										</Link>
									</SwiperSlide>
								))
							) : (
								<SkeletonSeriess />
							)}
						</Swiper>
					</div>

					<div className="more-btn">
						<a href="/pocket">
							<div className="more">
								<img src="/images/icon-lightning.svg" alt="" />
								<p>더보기</p>
							</div>
						</a>
					</div>
				</MoSeries>

				<div className="article-wrap">
					<h2 className="title">최신 아티클</h2>
					<div className="flex-wrap">
						<div className="left-box">
							{items?.length ? (
								items.map((item, key) => (
									<>
										<Link to={`/blog/${item?.ID}`} className="card-box">
											<div className="article-card" key={key}>
												<div className="cardimgbox">
													<div
														className="article-img"
														style={{
															backgroundImage: `url(${
																item?.thumbnail || '/images/no-image.png'
															})`,
														}}
													></div>
												</div>
												<div className="text-box">
													<div className="tag-box">
														{item?.tags?.length
															? item?.tags?.map((i, k) => (
																	<>
																		<p className="cate" key={k}>
																			#{i?.name}
																		</p>
																	</>
															  ))
															: null}
													</div>
													<h3>{item?.postTitle}</h3>
													<p className="content">{item?.postContent}</p>
													<div className="flex">
														<div className="user-box">
															{item.authors ? (
																<>
																	<a>
																		<div className="people">
																			{item.authors.map((i, k) => (
																				<a
																					className="user"
																					style={{
																						backgroundImage: `url(${i?.postAuthorImg})`,
																					}}
																				></a>
																			))}
																		</div>
																	</a>
																</>
															) : (
																<div className="alone">
																	<div
																		className="user"
																		style={{
																			backgroundImage: `url(${item?.postAuthorImg})`,
																		}}
																	></div>
																	<p>{item.postAuthorName}</p>
																</div>
															)}
														</div>
														{/* {item.authors ? null : <p>{item.postAuthorName}</p>} */}
														{item.series ? (
															<p className="name">
																<img src="/images/icon-lightning.svg" alt="" />
																{item?.series}
															</p>
														) : null}
														<p className="date">{item?.postDate}</p>
													</div>
												</div>
											</div>
										</Link>
										<div className="line"></div>
									</>
								))
							) : items ? (
								<>
									<SkeletonHomeArt />
									<SkeletonHomeArt />
									<SkeletonHomeArt />
									<SkeletonHomeArt />
									<SkeletonHomeArt />
									<SkeletonHomeArt />
									<SkeletonHomeArt />
									<SkeletonHomeArt />
								</>
							) : (
								<div className="result">
									<div className="result-box">
										<p>
											등록된 게시글이 없어요
											<br /> 게시글을 등록해보세요!
										</p>
									</div>
								</div>
							)}
						</div>
						{/* <div onClick={() => console.log(seriesNum)}>test</div> */}
						{/* <div onClick={() => console.log(series)}>series</div> */}
						<div className="right-box">
							{seriesNum?.length ? (
								seriesNum.slice(0, 6).map((item, key) => (
									<div className="shapes-box" key={key}>
										<Link to={`/blog/series/${item.key}`}>
											<div
												className="shapes-card"
												style={{
													backgroundImage: `url(${shuffle[key]?.thumbnail})`,
												}}
											></div>
											<p className="article-title">
												{item?.title}
												{/* {series[item?.key]?.title} */}
											</p>
											<p className="total">게시글 {item?.value}개 </p>
										</Link>
									</div>
								))
							) : (
								<>
									<SkeletonHomePocket />
									<SkeletonHomePocket />
									<SkeletonHomePocket />
									<SkeletonHomePocket />
									<SkeletonHomePocket />
									<SkeletonHomePocket />
								</>
							)}
							<div className="more-btn">
								<a href="/pocket">
									<div className="more">
										<img src="/images/icon-lightning.svg" alt="" />
										<p>더보기</p>
									</div>
								</a>
							</div>
						</div>
					</div>
					<div className="btn-wrap">
						<Link to={`/s`} className="more">
							<img src="/images/icon-more.svg" alt="" />
							<p>전체보기</p>
						</Link>
					</div>
				</div>
			</Wrapper>
		</Layout>
	);
};

export default Home;
